import styled from 'styled-components';
import { Switch as AntSwitch, SwitchProps } from 'antd';
import React from 'react';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: min-content;
    background-color: transparent;

    .ant-switch-inner {
      font-size: 22px;
    }

    .ant-switch,
    .ant-switch-checked {
        height: 32px;
        width: 64px;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .ant-switch{
        justify-content: flex-end;
    }
    .ant-switch-checked {
        justify-content: flex-start;
    }

    .ant-switch-handle {
      top: 20%;   
    }

    .ant-switch-checked {
      background: ${({ theme }) => theme.menuActive};
    }

    :hover {
        filter: brightness(1.1);
        transition: 0.3s;
    }

    svg{
        color: ${({ theme }) => theme.text};
        margin: 3px 0 0;
    }
`;


export const Switch: React.FC<SwitchProps> = styled(AntSwitch)`

`;

